module.exports = __webpack_public_path__ + "img/2012-08-18 09.21.22.a0a03ece.jpg";